<template>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <img src="@/assets/home/banner2.png" alt="">
                <div class="text">
                    <p>频谱认知</p>
                    <p>FREQUENCY SPECTRUM</p>
                    <div>
                        <span>无人机频谱认知仪</span>
                        <span>无人机频谱认知仪</span>
                        <span>无人机频谱认知仪</span>
                    </div>
                    <div class="button" @click="activeChange(3,2)"><p>了解详情</p></div>
                </div>
            </div>
            <div class="swiper-slide">
                <img src="@/assets/home/banner3.png" alt="">
                <div class="text">
                    <p>智能化</p>
                    <p>INTELLIGENT</p>
                    <div>
                        <span>星筑IBOS系统</span>
                        <span>星联IOT平台</span>
                        <span>数字配电智能预警控制系统</span>
                    </div>
                    <div class="button" @click="activeChange(3,3)"><p>了解详情</p></div>
                </div>
            </div>
<!--          <div class="swiper-slide">-->
<!--            <img src="@/assets/home/banner1.png" alt="">-->
<!--            <div class="text">-->
<!--              <p>致力于成为数字化创新<span>引领者</span></p>-->
<!--              <p>LEADER IN DIGITAL INNOVATION</p>-->
<!--              <div>-->
<!--                <span>物联网</span>-->
<!--                <span>云计算</span>-->
<!--                <span>大数据</span>-->
<!--              </div>-->
<!--              <div class="button" @click="activeChange(2,1)"><p>了解详情</p></div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <!-- 如果需要分页器 -->
        <div class="swiper-pagination"></div>

        <!-- 如果需要导航按钮 -->
        <div class="swiper-button-prev jt" ></div>
        <div class="swiper-button-next jt"></div>

        <!-- 如果需要滚动条 -->
        <!--        <div class="swiper-scrollbar"></div>-->
    </div>
</template>
<script>
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';

export default {
    name: "Banner",
    mounted() {
        new Swiper('.swiper-container', {
            // direction: 'vertical', // 垂直切换选项
            loop: true, // 循环模式选项
            autoplay: true,
            effect: 'fade', //渐隐效果
            grabCursor: false, //手形
            // 如果需要分页器
            pagination: {
                el: '.swiper-pagination',
            },

            // 如果需要前进后退按钮
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            // // 如果需要滚动条
            // scrollbar: {
            //     el: '.swiper-scrollbar',
            // },
        })
    },
    methods: {
        toPage(path) {
            this.$router.push({path: path}).catch(err => {
            })
        },
        activeChange(index, value) {
            sessionStorage.setItem('key', index);
            // console.log( typeof (sessionStorage.getItem('key')))
            // console.log( typeof (sessionStorage.getItem('key')))
            switch (value) {
                case 1:
                    this.toPage('/about.html')
                    break
                case 2:
                    this.toPage('/monitor.html')
                    break
                case 3:
                    this.toPage('/ibos.html')
                    break
            }
        },
    }
}

</script>
<style scoped lang="less">
@import "../styles/banner";
</style>